/**
 * @description 通用方法定义
 * @author aprilcai
 */

import { resultCode, resultMessage, filmPayUrl, wrapResult } from '../module/entity';
import { sendRequestService } from '../module/cgi';
import { loadH5LoginModule, loadMiniPayModule, getCookie } from '../module/util';
import { isMobile } from '../module/ua';
import pcSharePanel from './ui/pc-share-panel';
import toast from './ui/ui-toast';
// 获取用户信息
export async function $commonGetUserInfo(param: { data: any; isTest: boolean }): Promise<IResult> {
  return sendRequestService({
    service: 'getUserInfo',
    data: param.data,
    isTest: param.isTest,
  });
}

// 获取支付链接
export async function $getPayUrl(param: {
  appid?: string;
  actid?: string;
  orderid?: string;
  needpay?: string;
  close?: number;
  ru?: string;
  title?: string;
  sandbox?: number;
  autopay?: number;
}): Promise<IResult> {
  const basePayUrl = filmPayUrl;
  let payUrl = `${basePayUrl}?orderid=${param.orderid}&appid=${param.appid}&source=860&actid=${
    param.actid
  }&channel=6&needpay=${param.needpay || ''}&close=${param.close}&ru=${
    param.ru ? encodeURIComponent(param.ru) : ''
  }&title=${param.title ? encodeURIComponent(param.title) : ''}`;
  if (typeof param.sandbox !== 'undefined') {
    payUrl += `&sandbox=${param.sandbox}`;
  }
  if (typeof param.autopay !== 'undefined') {
    payUrl += `&autopay=${param.autopay}`;
  }
  return Promise.resolve({
    code: 0,
    msg: 'ok',
    result: {
      payUrl,
    },
  });
}

// 获取网络状态
export async function $getNetworkState(): Promise<IResult> {
  const { navigator } = window;
  const { connection, mozConnection, webkitConnection } = navigator as any;
  const con = connection
    || mozConnection
    || webkitConnection || {
    type: '',
    effectiveType: '',
  };
  const type = con?.type || con?.effectiveType || '';
  let state = 1;
  if (type === 'none') {
    state = 0;
  } else if (type === 'cellular') {
    state = 4;
  }
  return wrapResult(resultCode.ok, resultMessage.ok, {
    state,
    carrierSubscriptionValid: 0,
  });
}

// 获取音量
export async function $getVolume(): Promise<IResult> {
  const globalPlayerGetVolume = window?.globalPlayerGetVolume || { globalPlayerGetVolume: () => 0 };
  const volume = globalPlayerGetVolume();
  return wrapResult(resultCode.ok, resultMessage.ok, {
    volume,
  });
}

// 设置音量
export async function $setVolume(param: { volume: number }): Promise<IResult> {
  const globalPlayerSetVolume = window?.globalPlayerSetVolume || {
    globalPlayerSetVolume: () => {},
  };
  globalPlayerSetVolume(param.volume);
  return wrapResult(resultCode.ok, resultMessage.ok, {
    volume: param.volume,
  });
}

// 获取头像
export async function $getAvatar(type: string): Promise<string> {
  if (!isMobile) {
    return Promise.resolve(getCookie(`${type}_head`));
  }
  return new Promise((mainUserInfoResolve) => {
    loadH5LoginModule()
      .then(h5Login => h5Login.getMainUserInfo())
      .then((mainUserInfo) => {
        mainUserInfoResolve(mainUserInfo ? mainUserInfo.headurl : '');
      });
  });
}

// 打开VIP开通页/浮层
export async function $openPayVipView(param: {
  actid?: string;
  nt?: string;
  n?: string;
  sp?: string;
  ptag?: string;
  aid?: string;
  dsp?: string;
  tab?: string;
  dnp?: string;
  unwx?: string;
  url?: string;
}) {
  return new Promise((resolve) => {
    // TODO 将移动端和Pad端的参数一一对应上
    if (isMobile) {
      location.href = param.url;
    } else {
      loadMiniPayModule().then((miniPay) => {
        const miniPayParam = {
          ...param,
          ...{
            onSuccess: () => {
              resolve({
                code: 0,
                msg: 'ok',
                result: {},
              });
            },
            onClose: () => {
              resolve({
                code: -1,
                msg: 'cancel',
                result: {},
              });
            },
            onError: () => {
              resolve({
                code: -1,
                msg: 'error',
                result: {},
              });
            },
          },
        };
        miniPay.openApi.open(miniPayParam);
      });
    }
  });
}

// 分享
export async function $share(param: {
  title?: string;
  subTitle?: string;
  url?: string;
  imageUrl?: string;
  sharePageTitle?: string;
  sharePageLaunchUrl?: string;
  pcShareImageUrl?: string;
  pcShareImageWidth?: string;
  pcShareImageHeight?: string;
}): Promise<IResult> {
  if (!isMobile) {
    if (!param.pcShareImageUrl) {
      return wrapResult(resultCode.error, `${resultMessage.error}: no pcShareImageUrl found`);
    }
    pcSharePanel.create(param);
  }
  // TODO 移动端h5(设置分享之后)需要用户手动点击右上角分享
  return wrapResult(resultCode.ok, resultMessage.ok);
}

// toast
export async function $toast(content: string) {
  toast(content);
  return wrapResult(resultCode.ok, resultMessage.ok);
}
